import styled from 'styled-components';

export const PostContentModalLayout = styled.div`
  width: 100%;
  background: white;
  overflow: hidden;
  border-radius: 6px;
  display: flex;
  flex-direction: column;

  .modal-header-row {
    padding: 16px 12px;
    border-bottom: 1px solid #edf2f7;
    display: flex;
    align-items: center;
    justify-content: space-between;

    span {
      color: #495057;
      font-size: 16px;
      font-family: Poppins;
      font-weight: 600;
    }

    i {
      font-size: 20px;
      color: #484848;
      cursor: pointer;
    }
  }

  .modal-body-content {
    padding: 16px 12px;
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .form-control-group {
    display: flex;
    flex-direction: column;
    gap: 8px;
    position: relative;

    label {
      color: #4a5568;
      font-size: 14px;
      font-family: Inter;
      font-weight: 400;
    }
  }

  .date-picker-trigger {
    padding: 12px;
    background: white;
    border-radius: 6px;
    border: 1px solid #e2e8f0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;

    .date-picker-trigger-value {
      display: flex;
      align-items: center;
      gap: 8px;

      i {
        font-size: 20px;
        color: #718096;
      }

      span {
        color: rgba(0, 0, 0, 0.64);
        font-size: 16px;
        font-family: Inter;
        font-weight: 400;
      }
    }

    i.bx-chevron-down {
      font-size: 20px;
      color: #718096;
    }
  }

  .link-input {
    height: 48px;
    padding: 12px;
    background: white;
    border-radius: 6px;
    border: 1px solid #e2e8f0;
    color: #2d3748;
    font-size: 14px;
    font-family: Inter;

    &::placeholder {
      color: rgba(0, 0, 0, 0.36);
    }

    &:focus {
      outline: none;
      border-color: #48bb78;
    }
  }

  .modal-footer-row {
    padding: 16px 12px;
    border-top: 1px solid #edf2f7;
    display: flex;
    justify-content: flex-end;
    gap: 12px;

    button {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 40px;
      padding: 10px 16px;
      border-radius: 4px;
      border: none;
      font-size: 16px;
      font-family: Inter;
      font-weight: 600;
      cursor: pointer;

      &:disabled {
        opacity: 0.6;
        cursor: wait;
      }
    }

    .btn-cancel {
      background: #f7fafc;
      color: #4a5568;

      &:hover {
        background: #edf2f7;
      }
    }

    .btn-publish {
      background: #48bb78;
      color: white;

      &:hover {
        background: #38a169;
      }
    }
  }
`;

export const DatePickerPortal = styled.div`
  position: fixed;
  z-index: 1100;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  border-radius: 6px;
  overflow: hidden;
`;
